import { memo, useState } from "react";

import { classNames } from "shared/lib/classNames/classNames";

import cls from "./SociometryDeleteModal.module.scss";
import { Modal } from "shared/ui/Modal";
import { HStack, VStack } from "components/landingNew/shared/ui/Stack";
import { Icon } from "components/landingNew/shared/ui/Icon";
import { ReactComponent as CloseIcon } from "static/img/ic-close.svg";
import { Text } from "components/landingNew/shared/ui/Text";
import { Button } from "shared/ui/Button";
import axios from "axios";

interface SociometryDeleteModalProps {
    className?: string;
    isOpen: boolean;
    onClose: () => void;
    sessionId: string;
    syncClasses?: (sessionId: string) => void;
}

export const SociometryDeleteModal = memo((props: SociometryDeleteModalProps) => {
    const { className, isOpen, onClose, sessionId, syncClasses } = props;

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const deleteHandler = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        e.preventDefault();
        try {
            setIsLoading(true);
            const { data } = await axios.delete(`sociometry/delete/${sessionId}`);

            if (syncClasses && data) {
                syncClasses(sessionId);
            }
            onClose();
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal
            className={classNames(cls.sociometryDeleteModal, {}, [className])}
            isOpen={isOpen}
            onClose={onClose}
            lazy
            overlay
        >
            <div
                className={cls.closeButton}
                onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                    e.stopPropagation();
                    onClose();
                }}
            >
                <Icon Svg={CloseIcon} />
            </div>
            <VStack className={classNames("", {}, [className])} justify="center" gap={24}>
                <Text text="Хотите удалить?" size="l" align="center" />
                <VStack max gap={32}>
                    <Text
                        text={`Данная методика будет удалена у всех учеников и пройденные результаты не будут сохранены.`}
                    />

                    <HStack max justify="end" gap={20}>
                        <Button onClick={deleteHandler} color="red" isLoading={isLoading} size="medium">
                            Удалить
                        </Button>
                    </HStack>
                </VStack>
            </VStack>
        </Modal>
    );
});

SociometryDeleteModal.displayName = "SociometryDeleteModal";
